import { motion } from "framer-motion";
import { MapPin, Clock, Phone, Navigation } from "lucide-react";

export const Location = ({ content }) => {
  const l = content.location;
  return (
    <section id="lokasi" data-testid="location-section" className="py-20 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-sky-100 text-sky-700 text-sm font-semibold mb-4">
            Lokasi Kami
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Kunjungi Kami</h2>
          <p className="mt-4 text-base text-slate-500 leading-relaxed">
            Temukan kami dengan mudah. Kami menanti kedatangan Anda untuk berkonsultasi dan mendaftar.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-6 items-stretch">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-2 rounded-3xl bg-gradient-to-br from-slate-900 to-sky-950 p-8 sm:p-10 text-white flex flex-col justify-between shadow-xl"
          >
            <div>
              <h3 className="text-2xl font-bold mb-8">Informasi Lokasi</h3>
              <div className="space-y-7">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-sky-500/20 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-sky-300" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-sky-300 mb-1">Alamat</div>
                    <p data-testid="address-text" className="text-slate-200 leading-relaxed text-sm">
                      {l.address}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-sky-500/20 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-5 h-5 text-sky-300" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-sky-300 mb-1">Jam Operasional</div>
                    <p className="text-slate-200 text-sm">{l.hours}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-sky-500/20 flex items-center justify-center flex-shrink-0">
                    <Phone className="w-5 h-5 text-sky-300" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-sky-300 mb-1">Telepon / WhatsApp</div>
                    <p className="text-slate-200 text-sm">+{content.contact.whatsapp}</p>
                  </div>
                </div>
              </div>
            </div>

            <a
              href={l.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="directions-button"
              className="mt-9 inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-sky-500 hover:bg-sky-400 text-white font-semibold transition-colors"
            >
              <Navigation className="w-5 h-5" />
              Buka di Google Maps
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="lg:col-span-3 rounded-3xl overflow-hidden shadow-xl border border-slate-200 min-h-[420px]"
          >
            <iframe
              title="Lokasi ADHISATYA COURSE"
              data-testid="google-map"
              src={l.mapsEmbed}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "420px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
